import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

import { Button } from "@mui/material";

import { useNavigate } from "react-router-dom";
import * as Constants from "../../Constants";
export default function ApplicantsTable() {
  const [applicants, setApplicants] = React.useState([]);
  const [err, setErr] = React.useState(null);
  const [refresh, setRefresh] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(true);
  const navigate = useNavigate();
  axios.defaults.withCredentials = true 

  
  function hideApplicant(id) {
    setApplicants(
      applicants.map((applicant) => {
        if (applicant.id == id) {
          let newApplicant = applicant;
          newApplicant.hidden = 1;
          return newApplicant;
        }
        return applicant;
      })
    );
    setRefresh(refresh + 1);
    if (id) {
      axios
        .patch(`${Constants.API_URL}/hide_applicant/${id}`)
        .then((res) => {
          setRefresh(refresh + 1);
        })
        .catch((err) => {
          setErr(err.response.data);
        });
    }
  }

  function showApplicants() {
    setApplicants(
      applicants.map((applicant) => {
        let newApplicant = applicant;
        newApplicant.hidden = 0;
        return newApplicant;
      })
    );
    setRefresh(refresh + 1);
    axios
      .patch(`${Constants.API_URL}/show_applicants`)
      .then((res) => {
        setRefresh(refresh + 1);
      })
      .catch((err) => {
        setErr(err.response.data);
      });
  }

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 60,
    },
    {
      field: "firstName",
      headerName: "First Name",
      minWidth: 100,
      flex: 2,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      minWidth: 100,
      flex: 2,
    },
    {
      field: "org",
      headerName: "Organization",
      minWidth: 100,
      flex: 2,
    },
    {
      field: "email",
      headerName: "E-mail",
      minWidth: 200,
      flex: 3,
    },
    {
      field: "found",
      headerName: "Found",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "stateName",
      headerName: "State",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "timestamp",
      headerName: "Timestamp",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "pricingPlan",
      headerName: "Pricing Plan",
      minWidth: 70,
      flex: 1,
    },
    {
      field: "Action",
      disableColumnMenu: true,
      minWidth: 250,
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        const onClickHide = (e) => {
          e.stopPropagation();
          hideApplicant(params.row.id);
        };

        return (
          <>
            <Button size="small" variant="contained" onClick={onClickHide}>
              Hide
            </Button>
            <Button
              disabled={params.row.stateName == "Account created"}
              size="small"
              variant="contained"
              onClick={() => navigate(`/register_new_user/` + params.row.id)}
            >
              Create Account
            </Button>
          </>
        );
      },
    },
  ];

  React.useEffect(() => {
    axios
      .get(`${Constants.API_URL}/get_applicants`)
      .then((res) => {
        setApplicants(res.data.applicants);
        setIsLoading(false);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, []);

  return (
    <React.Fragment>
      {err ? (
        <p>{err}</p>
      ) : (
        <div
          id="m"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "flex-end",
          }}
        >
          {/* <h4 style={{ alignSelf: "flex-start" }}>Applicants</h4> */}
          <Box
            sx={{
              height: 400,
              width: "100%",
            }}
          >
            <DataGrid
              // getRowHeight={() => "auto"}
              loading={isLoading}
              rows={applicants.filter((applicant) => applicant.hidden === 0)}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "desc" }],
                },
              }}
            />
          </Box>
          <Button variant="contained" onClick={showApplicants}>
            Show all
          </Button>
        </div>
      )}
    </React.Fragment>
  );
}
